import { render } from "./OfficialTotal.vue?vue&type=template&id=9882d402&scoped=true"
import script from "./OfficialTotal.vue?vue&type=script&lang=js"
export * from "./OfficialTotal.vue?vue&type=script&lang=js"

import "./OfficialTotal.vue?vue&type=style&index=0&id=9882d402&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9882d402"]])

export default __exports__